import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const BatchReview = () => {
  const { batchId } = useParams();
  const navigate = useNavigate();
  const [notes, setNotes] = useState('');

  const batch = {
    batch_id: 1,
    batch_name: 'SchwenkfelderLibrary_20251128_224625',
    total_images: 3,
    passed_images: 3,
    failed_images: 0,
    status: 'waiting',
  };

  const handleApprove = () => {
    console.log('Approving batch with notes:', notes);
    // Functionality will be added later
  };

  const handleReject = () => {
    console.log('Rejecting batch with notes:', notes);
    // Functionality will be added later
  };

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
    },
    header: {
      backgroundColor: 'white',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      borderBottom: '1px solid #e5e7eb',
    },
    headerContent: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '20px 30px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    titleSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
    },
    logo: {
      width: '48px',
      height: '48px',
      background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '24px',
      fontWeight: 'bold',
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#1f2937',
      margin: 0,
    },
    subtitle: {
      fontSize: '14px',
      color: '#6b7280',
      margin: '2px 0 0 0',
    },
    backButton: {
      padding: '10px 20px',
      backgroundColor: '#6b7280',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
    },
    mainContent: {
      maxWidth: '1000px',
      margin: '0 auto',
      padding: '40px 30px',
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '32px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e5e7eb',
      marginBottom: '24px',
    },
    cardTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '20px',
    },
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '16px',
      marginBottom: '24px',
    },
    statItem: {
      textAlign: 'center',
      padding: '16px',
      backgroundColor: '#f9fafb',
      borderRadius: '8px',
    },
    statLabel: {
      fontSize: '12px',
      color: '#6b7280',
      marginBottom: '4px',
    },
    statValue: {
      fontSize: '24px',
      fontWeight: 'bold',
    },
    decisionSection: {
      marginTop: '24px',
    },
    label: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#374151',
      marginBottom: '8px',
      display: 'block',
    },
    textarea: {
      width: '100%',
      padding: '12px',
      border: '2px solid #e5e7eb',
      borderRadius: '8px',
      fontSize: '14px',
      fontFamily: 'inherit',
      resize: 'vertical',
      minHeight: '120px',
    },
    buttonGroup: {
      display: 'flex',
      gap: '12px',
      marginTop: '24px',
    },
    rejectButton: {
      flex: 1,
      padding: '16px',
      backgroundColor: '#ef4444',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    approveButton: {
      flex: 1,
      padding: '16px',
      background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    infoBox: {
      backgroundColor: '#eff6ff',
      border: '1px solid #bfdbfe',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '24px',
    },
    infoText: {
      fontSize: '14px',
      color: '#1e40af',
      lineHeight: '1.6',
    },
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.titleSection}>
            <div style={styles.logo}>📋</div>
            <div>
              <h1 style={styles.title}>Review & Approve Batch</h1>
              <p style={styles.subtitle}>{batch.batch_name}</p>
            </div>
          </div>
          <button
            onClick={() => navigate(`/batch/${batchId}`)}
            style={styles.backButton}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
          >
            ← Back to Batch
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={styles.mainContent}>
        <div style={styles.infoBox}>
          <div style={styles.infoText}>
            <strong>👤 Auditor Review:</strong> Review the batch validation results and decide whether to approve or reject this batch.
            All images have been validated and are ready for your review.
          </div>
        </div>

        {/* Batch Summary */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Batch Summary</h2>
          <div style={styles.statsGrid}>
            <div style={styles.statItem}>
              <div style={styles.statLabel}>Total Images</div>
              <div style={{ ...styles.statValue, color: '#1f2937' }}>{batch.total_images}</div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statLabel}>Passed</div>
              <div style={{ ...styles.statValue, color: '#10b981' }}>{batch.passed_images}</div>
            </div>
            <div style={styles.statItem}>
              <div style={styles.statLabel}>Failed</div>
              <div style={{ ...styles.statValue, color: '#ef4444' }}>{batch.failed_images}</div>
            </div>
          </div>
        </div>

        {/* Decision Form */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Auditor Decision</h2>

          <div style={styles.decisionSection}>
            <label style={styles.label}>Review Notes (Optional)</label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              style={styles.textarea}
              placeholder="Enter any notes or comments about this batch..."
              onFocus={(e) => e.target.style.borderColor = '#8b5cf6'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
            />
          </div>

          <div style={styles.buttonGroup}>
            <button
              onClick={handleReject}
              style={styles.rejectButton}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#dc2626'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#ef4444'}
            >
              <span>❌</span>
              <span>Reject Batch</span>
            </button>
            <button
              onClick={handleApprove}
              style={styles.approveButton}
              onMouseEnter={(e) => e.target.style.opacity = '0.9'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >
              <span>✅</span>
              <span>Approve Batch</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatchReview;